export const EuroCircleIcon: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.7515 8.02353C12.5583 7.92217 13.3833 8.1502 14.0749 8.69124C14.4949 9.01981 14.8495 9.45182 15.1115 9.95894C15.3649 10.4496 15.9681 10.642 16.4588 10.3885C16.9495 10.1351 17.1419 9.53184 16.8884 9.04114C16.5019 8.29278 15.9665 7.63181 15.3073 7.11605C14.2142 6.26083 12.8601 5.86853 11.5022 6.03914C10.1462 6.20951 8.91789 6.92422 8.03555 8.01249C7.67044 8.46282 7.37395 8.96514 7.15062 9.50004H5.995C5.44271 9.50004 4.995 9.94775 4.995 10.5C4.995 11.0523 5.44271 11.5 5.995 11.5H6.67267C6.66209 11.6391 6.6559 11.7788 6.65417 11.9191C6.65178 12.1136 6.65801 12.3075 6.67267 12.5H5.99995C5.44767 12.5 4.99995 12.9478 4.99995 13.5C4.99995 14.0523 5.44767 14.5 5.99995 14.5H7.15062C7.35345 14.9859 7.6168 15.4452 7.93759 15.8634C8.79133 16.9764 9.99968 17.7276 11.35 17.9394C12.7026 18.1516 14.0671 17.8013 15.183 16.9785C15.8982 16.451 16.4773 15.755 16.8884 14.9589C17.1419 14.4682 16.9495 13.865 16.4589 13.6116C15.9682 13.3581 15.3649 13.5504 15.1115 14.0411C14.8328 14.5807 14.4496 15.0342 13.9959 15.3688C13.2934 15.8869 12.4645 16.0898 11.6599 15.9636C10.8006 15.8288 9.98427 15.3135 9.41771 14.5H12C12.5523 14.5 13 14.0523 13 13.5C13 12.9478 12.5523 12.5 12 12.5H8.68101C8.66087 12.3166 8.65172 12.1307 8.65402 11.9436C8.65586 11.7946 8.66493 11.6465 8.68101 11.5H11.995C12.5473 11.5 12.995 11.0523 12.995 10.5C12.995 9.94775 12.5473 9.50004 11.995 9.50004H9.41771C9.96057 8.72056 10.7979 8.14335 11.7515 8.02353Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
        fill="currentColor"
      />
    </svg>
  );
};
